import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';

import { JobRoutingModule } from './job-routing.module';
import { JobComponent } from './job.component';
import { JobBSRComponent } from './job-bsr/job-bsr.component';
import { JobSSRComponent } from './job-ssr/job-ssr.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { organizationKey } from '../organization/store/organization.actions';
import { organizationReducer } from '../organization/store/organization.reducer';
import { OrganizationEffects } from '../organization/store/organization.effects';

@NgModule({
  declarations: [JobComponent, JobBSRComponent, JobSSRComponent],
  imports: [
    CommonModule,
    SharedModule,
    JobRoutingModule,
    StoreModule.forFeature(organizationKey, organizationReducer),
    EffectsModule.forFeature([OrganizationEffects])
  ]
})
export class JobModule {}
